var UrlFormatter = Object.create(null),
    StrFormatter = require('./StrFormatter');

/**
 * @typedef {object} SearchObj
 * @property {?number} day - Jour
 * @property {?number} month - Mois
 * @property {?number} year - Année
 */

UrlFormatter.formaterSeoUrl = formaterSeoUrl;
UrlFormatter.formaterUrl = formaterUrl;
UrlFormatter.formatSocialNameUrl = formatSocialNameUrl;
UrlFormatter.urlEncode = urlEncode;
UrlFormatter.formatShowUrl = formatShowUrl;
UrlFormatter.formatUrlWithPlaceholders = formatUrlWithPlaceholders;
UrlFormatter.addUrlLangAndSource = addUrlLangAndSource;
UrlFormatter.extractReturnurl = extractReturnurl;
UrlFormatter.getSearchObj = getSearchObj;
UrlFormatter.formatWebsiteUrl = formatWebsiteUrl;
UrlFormatter.addForceReturnUrl = addForceReturnUrl;

/**
 * Modification de l'URL en y ajoutant la langue et la source su présente
 * @param {string} url - URL à modifié
 * @param {string} lang - Langue
 * @param {string} source - Source
 * @returns {string}
 * TU TODO 🔨
 */
function addUrlLangAndSource(url, lang, source) {
  var modifiedUrl = url,
      findedParams = false;

  if (!url) {
    return '';
  }

  if (url.match(/\?/g)) {
    findedParams = true;
  }

  if (source) {
    modifiedUrl = `${ url }${ findedParams ? '&' : '?' }source=${ source }`;
  }

  return modifiedUrl;
}

/**
 * Permet d'extraire l'URL de retour d'une URL en supprimant les paramètres
 * @param {string|Array<string>|object|null|undefined} strUrl - URL à analyser
 * @param {string} strUrlReplacement - URL de remplacement si on ne retrouve pas de returnurl
 * @returns {string}
 * TU DONE 🗸
 */
function extractReturnurl(strUrl, strUrlReplacement) {
  const safeUrl = typeof strUrl === 'string'
    ? strUrl
    : Array.isArray(strUrl)
      ? strUrl[0] || ''
      : '';

  const splitedUrl = safeUrl.split('returnurl=');
  const returnUrlStr = splitedUrl?.[1];

  return returnUrlStr ? returnUrlStr.split('&')[0] : strUrlReplacement;
}
/**
 * Permet de récupérer les objets de recherche de l'url pour une recherche ou on doit chercher par date, mois et année mais avec la date qui peut-être "tous les jours du mois"
 * @param {import('../../jsdoc/expressjs.jsdoc').ModifiedRequest} request - Objet request d'ExpressJS
 * @returns {SearchObj} - Objet de recherche
 * TU TODO 🔨
 */
function getSearchObj(request) {
  var queryDay = request.query.day || null,
      queryMonth = request.query.month,
      queryYear = request.query.year,
      day = queryDay ? parseInt(queryDay, 10) : null,
      month = queryMonth ? parseInt(queryMonth, 10) : null,
      year = queryYear ? parseInt(queryYear, 10) : null;

  return {
    day,
    month,
    year
  };
}

/**
 * Permet de formatter une URL
 * @param {string} url - URL à formatter
 * @returns {string} - URL formattée
 * TU TODO 🔨
 */
function urlEncode(url) {
  var formattedUrl = url;

  if (!formattedUrl) {
    return '';
  }

  formattedUrl = formattedUrl.toLowerCase();
  formattedUrl = formattedUrl.replace(/'/g, '-');
  formattedUrl = formattedUrl.replace(/ /g, '-');
  formattedUrl = formattedUrl.replace(/--/g, '-');
  formattedUrl = formattedUrl.replace(/"/g, '-');
  formattedUrl = formattedUrl.replace(/é/g, 'e');
  formattedUrl = formattedUrl.replace(/è/g, 'e');
  formattedUrl = formattedUrl.replace(/à/g, 'a');
  formattedUrl = formattedUrl.replace(/ç/g, 'c');
  return formattedUrl;
}

/**
 * Permet de formatter une chaîne pour une URL SEO
 * @param {string} string - Chaîne à formatter
 * @returns {string} La chaîne formatté
 * TU TODO 🔨
 */
function formaterSeoUrl(string) {
  string = string.toLowerCase();
  string = string.replace(/%/g, '');
  string = string.replace(/'/g, '-');
  string = string.replace(/#/g, '');
  string = string.replace(/ /g, '-');
  string = string.replace(/--/g, '-');
  string = string.replace(/\//g, '-');
  string = string.replace(/"/g, '-');
  string = string.replace(/é/g, 'e');
  string = string.replace(/è/g, 'e');
  string = string.replace(/à/g, 'a');
  string = string.replace(/ç/g, 'c');

  return string;
}

/**
 * Permet de formatter une chaîne en fonction des paramètres fournis
 * @param {string} str - Chaîne à formatter
 * @param {'default'|'instagram'|'facebook'} type - Type du formattage à appliquer
 * @returns {string} La chaîne formatté
 * TU TODO 🔨
 */
function formaterUrl(str, type) {
  var formattedStr;

  switch (type) {
    case 'default':
      if (!str.match(/http/g)) {
        str = `https://${ str }`;
      }
      formattedStr = str;
      break;
    case 'facebook':
      formattedStr = formatSocialNameUrl(str, 'facebook', true);
      break;
    case 'instagram':
      formattedStr = formatSocialNameUrl(str, 'instagram', true);
      break;
  }

  return formattedStr;
}

/**
 * Permet de formatter une url d'un réseau social
 * @param {string} str - Chaîne à formatter
 * @param {string} socialName - Nom du réseau social
 * @param {boolean} https - True s'il faut du https sinon false
 * @returns {string} La chaîne formatté
 * TU TODO 🔨
 */
function formatSocialNameUrl(str, socialName, https) {
  var regex = new RegExp(`www.${ socialName }.com`, 'g'),
      strHttp = https ? 'https' : 'http';

  if (!str.match(/http/g)) {
    str = str.match(regex) ? `${ strHttp }://${ str }` : `${ strHttp }://www.${ socialName }.com/${ str }`;
  }

  return str;
}

/**
 * Permet de formatter l'URL d'une vue show
 * @param {string} url - URL à formatter
 * @param {string} modelNameInUrl - Nom du modèle dans l'URL
 * @param {object} item - Objet de la ligne
 * @param {number} includingId - Identifiant de la données incluse, c'est la donnée principale chargée sur la view show
 * @returns {string} - URL formattée
 * TU TODO 🔨
 */
function formatShowUrl(url, modelNameInUrl, item, includingId) {
  url = url.replace(/\[\[parentId\]\]/g, includingId.toString()).replace(/\[\[parentModel\]\]/g, modelNameInUrl);
  url += url.match(/\?/g) ? `&includingId=${ item.id }&includingModel=${ modelNameInUrl }` : `?includingId=${ item.id }&includingModel=${ modelNameInUrl }`;
  return url;
}

/**
 * Remplace les propriétés d'un objet dans une URL
 * @param {string} url - URL à formatter
 * @param {object} item - Objet contenant les propriétés à remplacer
 * @param {?string} [modelNameInUrl] - Nom du modèle dans l'URL
 * @returns {string} - URL formattée
 * TU DONE 🗸
 */
function formatUrlWithPlaceholders(url, item, modelNameInUrl = null) {
  url = url.replace(/\[\[item\.(\w+)\]\]/g, (match, prop) => {
    return item[prop] ? item[prop] : match;
  });

  url = url.replace('[[encryptId item.id]]', StrFormatter.encryptId(item.id));

  if (modelNameInUrl) {
    url = url.replace('[[modelName]]', modelNameInUrl);
  }

  return url;
}

/**
 * Permet de formatter l'url du site renseigner dans les options
 * @param {?string} url - URL à formatter
 * @returns {string} - URL formattée
 * TU DONE 🗸
 */
function formatWebsiteUrl(url) {
  if (!url) {
    return '';
  }

  url = url.split('?')[0];
  url = url.replace(/\/+$/, '');
  url = url.trim();

  return url;
}

/**
 * Permet d'ajouter le paramètre forcereturnurl à une URL
 * @param {string} url - URL à formatter
 * @param {string} forceReturnUrlValue - Valeur du paramètre forcereturnurl
 * @returns {string} - URL formattée
 * TU DONE 🗸
 */
function addForceReturnUrl(url, forceReturnUrlValue) {
  if (url.endsWith('?') || url.endsWith('&')) {
    return `${ url }forcereturnurl=${ forceReturnUrlValue }`;
  } else if (!url.includes('?')) {
    return `${ url }?forcereturnurl=${ forceReturnUrlValue }`;
  } else if (!url.includes('forcereturnurl=')) {
    return `${ url }&forcereturnurl=${ forceReturnUrlValue }`;
  } else {
    return url.replace(/forcereturnurl=[^&]*/, `forcereturnurl=${ forceReturnUrlValue }`);
  }
}

module.exports = UrlFormatter;
